<script setup>
// Thin capacity bar (mockups/redesign/meet.html .cap-bar) — green fill,
// amber when full. Percent 0–100; unlimited-capacity meets shouldn't render it.
defineProps({
  percent: {type: Number, default: 0},
  full: {type: Boolean, default: false},
});
</script>

<template>
  <div class="cap-bar">
    <div class="cap-bar__fill" :class="{'cap-bar__fill--full': full}" :style="{width: `${percent}%`}"/>
  </div>
</template>

<style scoped lang="scss">
.cap-bar {
  height: 6px;
  border-radius: 999px;
  background: rgb(var(--v-theme-bg));
  border: 1px solid rgb(var(--v-theme-borderLight));
  overflow: hidden;

  &__fill {
    height: 100%;
    border-radius: 999px;
    background: rgb(var(--v-theme-success));

    &--full {
      background: rgb(var(--v-theme-warning));
    }
  }
}
</style>
